import {Link} from 'react-router-dom'
import {routes} from '../../../routes'
import {NoAppointmentsIcon} from '../../../icons'
import classNames from 'classnames'
import NavigationHelper from '../../../utils/navigation'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const TrialPeriodContent = ({isDarkMode}) => {
    const text = useNamespaceTranslations('billings')
    return (
        <div className={classNames('empty-content-body', {
            dark: isDarkMode
        })}>
            <NoAppointmentsIcon/>
            <p dangerouslySetInnerHTML={{__html: text.trial_period_text}}/>
            <Link className="simple-blue-button" to={NavigationHelper.getLocalizedPath(routes.plans.paths)}>{text.plans}</Link>
        </div>
    )
}

export default TrialPeriodContent
